import _ from 'lodash'

export const limitStr = (str, take = 5) => {
  if (str.length <= take + 1 || !_.isString(str)) return str
  const strLimit = _.chain(str)
    .trim()
    .split('')
    .take(take)
    .join('')
    .value()
  return `${strLimit}...`
}

export default {
  limitStr
}
